export enum AdditionalFormFieldType {
    MEETING = 1,
    NEGOTIATION = 2
}
